import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=03652518&"
import script from "./ContentItem.vue?vue&type=script&lang=js&"
export * from "./ContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports